module.exports = __webpack_public_path__ + "img/SES_140250025.8bf41d74.jpg";